import { EventJournalQueries } from '@entities/eventJournal/model/queries';
import { useNuqsQueryState } from '@shared/hooks';

export const usePeriodPickerQueries = () => {
    const { state: periodPickerQueryValue, setState: setPeriodPickerQueryValue } =
        useNuqsQueryState(EventJournalQueries.period);

    const clearPeriodPickerQueryValue = () => {
        void setPeriodPickerQueryValue(null);
    };

    return {
        periodPickerQueryValue,
        setPeriodPickerQueryValue,
        clearPeriodPickerQueryValue,
    };
};
